import * as React from "react"
import { storyblokEditable, StoryblokComponent } from "gatsby-source-storyblok"
import { renderRichText } from "gatsby-source-storyblok"
import * as styles from "./tourItem.module.css"
import * as ricktextStyles from "./richtext.module.css"
import TourTags from "./tourTags"
import TourCarousel from "./tourCarousel"
import TourAcommodation from "./tourAccomodation"
import TourNote from "./tourNote"
import TourItinerary from "./tourItinerary"
import TourCheckout from "./tourCheckout"
import { Lang, LangEnum, Trans } from "../utils/lang"
import TourPeriod from "./tourPeriod"
import { EnergyLevel } from "../utils/enums"

const TourItem = ({ blok }) => {
  // console.log(blok)
  const lang = Lang()

  let currencyFormat = blok.currency?.includes("JPY") ? 
  new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' })
  : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

  const displaySeason = blok.season?.length > 0
  
  return (
    <div {...storyblokEditable(blok)}>
      {/* tour title */}
      <div className="relative bg-cover bg-center text-white" style={{ 'backgroundImage': `url(${blok.bannerBgImage?.filename}/m/)` }}>
        <div className="bg-black bg-opacity-30">
          <div className="container mx-auto p-4">
            <nav className="text-center pt-28">
              { lang == LangEnum.EN &&
              <>
                <a href={`${lang}/`} className="hover:text-gray-300 border-b-2">{Trans('home')}</a>
                <img src="/icons/breadcrumb-arrow-right.svg" alt="breadcrumb" className="inline-block w-4 h-4 mx-4" />
                <a href={`${lang}/tours`} className="hover:text-gray-300 border-b-2">{Trans('japanTours')}</a>
                <div className="w-full">
                  <img src="/icons/breadcrumb-arrow-down.svg" alt="breadcrumb" className="ml-24 inline-block w-4 h-4 my-4" />
                </div>
              </>
              }
            </nav>
            <div className="text-center pb-32">
              <h2 className="text-xl mb-4">{blok.tourSubHeading}</h2>
              <h1 className="text-4xl font-bold font-serif">{blok.tourTitle}</h1>
              {blok.tourCode && <p className="mt-3"><b>{Trans('tourCode')}</b>: {blok.tourCode}</p>}
            </div>
          </div>
          {/* <div className="border-t">
            <div className="grid grid-cols-4 lg:max-w-[1000px] container mx-auto text-center">
              <a href="#overview" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Overview</a>
              <a href="#itinerary" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Itinerary</a>
              <a href="#accomodations" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Accommodations</a>
              <a href="#notes" className="lg:text-lg py-3 border-x hover:bg-slate-100 hover:bg-opacity-40">Notes</a>
            </div>
          </div> */}
        </div>
      </div>
      
      <div className="sticky top-0 border-t border-b bg-cover bg-bottom text-white bg-gray-300 z-[9]" style={{'backgroundImage': `url(${blok.bannerBgImage?.filename}/m/)` }}>
        <div className="backdrop-blur-sm backdrop-brightness-75">
          <div className={`grid grid-cols-2 ${blok.hideAccommodation ? 'sm:grid-cols-3' : 'sm:grid-cols-4'} lg:max-w-[1000px] container mx-auto text-center`}>
            <a href="#overview" className="lg:text-lg py-3 border-r sm:border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">{Trans('overview')}</a>
            <a href="#itinerary" className="lg:text-lg py-3 sm:border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">{Trans('itinerary')}</a>
            {!blok.hideAccommodation && <a href="#accomodations" className="lg:text-lg py-3 border-r sm:border-x border-b sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40">{Trans('accommodations')}</a>}
            <a href="#notes" className={`lg:text-lg py-3 sm:border-x border-b ${blok.hideAccommodation ? 'border-r' : ''} sm:border-b-0 hover:bg-slate-100 hover:bg-opacity-40`}>{Trans('notes')}</a>
          </div>
        </div>
      </div>

      {/* sticky book now button */}
      { blok.shopifyBuyNowButton && 
      <a href="#checkout" className="sticky top-[80px] p-5 h-0 flex justify-end z-[9]">
        <button className="text-center bg-blue-700 hover:bg-blue-800 text-white font-bold rounded-full h-[100px] w-[100px] shadow-[4px_4px_black] focus:shadow-[1px_1px_black]">
        Book Now
        </button>
      </a>
      }
      

      {/* tour tags */}
      {/* <TourTags blok={blok} /> */}
      
      {/* tour schedule */}
      <div id="overview" className="container mx-auto py-8 pt-20 md:pt-8 border-b">
        <div className={`grid grid-cols-2 ${displaySeason ? 'md:grid-cols-4' : 'md:grid-cols-3'} lg:max-w-[1000px] mx-auto text-center`}>
      
            {/* tour days */}
            <div className={`py-3 grid-rows-2 border-r-2 border-black`}>
              <div className="pb-2 text-lg font-bold border-b border-gray-200">{Trans('duration')}</div>
              <div className="pt-3 flex flex-row justify-center">
                { lang == LangEnum.EN &&
                <div>
                  <h3 className="text-2xl font-bold">{blok.durationDays}</h3>
                  <p className="text-sm">{blok.durationDays <= 1 ? 'Day' : 'Days'}</p>
                </div>
                }
                { lang == LangEnum.EN && blok.durationNights > 0 &&
                <>
                <div className="h-10 -skew-x-12 mx-5 border-l border-black"></div>
                { 
                <div className="">
                  <h3 className="text-2xl font-bold">{blok.durationNights}</h3>
                  <p className="text-sm">{blok.durationNights <= 1 ? 'Night' : 'Nights'}</p>
                </div>
                }
                </>
                }

                { lang == LangEnum.JA && blok.durationNights > 0 &&
                <>
                  <div>
                    <h3 className="text-2xl font-bold">{blok.durationNights}</h3>
                    <p className="text-sm">泊</p>
                  </div>
                   <div className="h-10 -skew-x-12 mx-5 border-l border-black"></div>
                </>
                }
                { lang == LangEnum.JA &&
                  <div>
                    <h3 className="text-2xl font-bold">{blok.durationDays}</h3>
                    <p className="text-sm">日</p>
                  </div>
                }
              </div>
            </div>

            {/* tour price */}
            <div className={`py-3 grid-rows-2 md:border-r-2 border-black`}>
              <div className="pb-2 text-lg font-bold border-b border-gray-200">{Trans('price')} {blok.currency}</div>
              <div className="pt-3">
                <div className="flex flex-row justify-center align-baseline">
                  {blok.basePrice && <div className="text-gray-600 line-through mr-2">{currencyFormat.format(blok.basePrice)}</div>}
                  <div className="text-2xl font-bold">
                    { !blok.price && <a href="#multi-step-form">Ask</a> }
                    { blok.price && currencyFormat.format(blok.price) }
                    { blok.pricingNote && 
                    <span className="group relative">
                      <img className="inline h-[16px] ml-1 mb-2 cursor-pointer" src="/icons/caution-red.svg" alt="caution"/>
                      <div role="tooltip" className="z-[1] w-[230px] top-[25px] left-[-180px] group-hover:opacity-100 opacity-0 absolute inline-block ml-1 px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm tooltip dark:bg-gray-700">
                        {blok.pricingNote}
                      </div>
                    </span>
                    }
                  </div>
                </div>
                <div className="text-sm">{blok.pricingBasis}</div>
              </div>
            </div>

            {/* tour season */}
            { displaySeason && 
            <div className={`py-3 grid-rows-2 border-r-2 border-black border-t-2 md:border-t-0`}>
              <div className="pb-2 text-lg font-bold border-b border-gray-200">Season</div>
              <div className="pt-3">
                
                {blok.season && blok.season.map((seasonName, i) => (
                  <div key={i} className="flex flex-row justify-center align-baseline h-[35px]">
                    {seasonName != 'all seasons' && <img className="mr-2 w-[25px]" loading="lazy" src={`/icons/${seasonName}.svg`} alt="" />}
                    <span className="text-lg font-bold capitalize min-w-[70px] text-left">{seasonName}</span>
                  </div>
                ))}
              
              </div>
            </div>
            }

            {/* tour period */}
            <div className={`py-3 grid-rows-2 ${displaySeason ? '' : 'col-span-2 md:col-span-1'} border-black border-t-2 md:border-t-0 text-center`}>
              <div className="pb-2 text-lg font-bold border-b border-gray-200">{Trans('tourPeriod')}</div>
              <TourPeriod blok={blok} />
            </div>


        </div>
      </div>

      {/* energy level, EN only */}
      { lang == LangEnum.EN && 
      <div className="container text-center pt-2 mx-auto">
        {blok.energyLevel &&
        <div className="inline-flex p-2">
          <span className="text-lg font-bold border-black px-2">Energy Level: </span>
          <span className="self-center">{EnergyLevel[blok.energyLevel]}</span>
        </div>}
      </div>}

      {/* tour overview */}
      <div className="container max-w-[700px] mx-auto py-10 text-center">
        <h2 className="text-3xl font-bold">{blok.overviewHeading}</h2>
        <div className={`py-5 ${ricktextStyles.richText}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.overviewDescription) }}></div>
        {blok.overviewBlocks?.map((b) => (
          <StoryblokComponent blok={b} key={b._uid} />
        ))}
      </div>

      <TourCarousel blok={blok} />
      
      <TourItinerary blok={blok} />

      {!blok.hideAccommodation &&
      <TourAcommodation blok={blok} />
      }

      <TourNote blok={blok} />

      <TourCheckout blok={blok} />

       {blok.body?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>)
};

export default TourItem;
